import React from 'react';

const DividerFormGroup = () => <hr style={{ width: '100%', gridColumn: '1 / 6', borderBottom: 0 }} />;

export default DividerFormGroup;
